import React from 'react';
import { Modal, Tag, Typography, Space, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { releaseNotes } from '../../data/releaseNotes';
import { getLatestReleaseVersion } from '../../utils/version';

const { Text, Title } = Typography;

const TAG_COLORS = {
  feature: 'blue',
  fix: 'orange',
};

const WhatsNewModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { markWhatsNewSeen } = useAuth();
  const latestVersion = getLatestReleaseVersion();

  const handleClose = async () => {
    if (latestVersion) {
      await markWhatsNewSeen(latestVersion);
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      title={<Title level={4} style={{ margin: 0 }}>{t('whatsNew.title')}</Title>}
      width="min(560px, 95vw)"
      data-testid="whats-new-modal"
    >
      {releaseNotes.map((release, releaseIndex) => (
        <div key={release.version}>
          {releaseIndex > 0 && <Divider />}
          <Space style={{ marginBottom: 12 }}>
            <Text strong style={{ fontSize: 15 }}>v{release.version}</Text>
            <Text type="secondary" style={{ fontSize: 13 }}>{release.date}</Text>
          </Space>
          <Space direction="vertical" style={{ width: '100%' }} size={10}>
            {release.items.map((item) => (
              <div key={item.key} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <Tag
                  color={TAG_COLORS[item.type] ?? 'default'}
                  style={{ flexShrink: 0, marginTop: 2 }}
                  data-testid={`whats-new-tag-${item.type}`}
                >
                  {t(`whatsNew.tag.${item.type}`)}
                </Tag>
                <div>
                  <Text strong style={{ display: 'block', lineHeight: '22px' }}>
                    {t(`${item.key}.title`)}
                  </Text>
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    {t(`${item.key}.description`)}
                  </Text>
                </div>
              </div>
            ))}
          </Space>
        </div>
      ))}
    </Modal>
  );
};

export default WhatsNewModal;
